import {
  DailyVideo,
  useLocalSessionId,
  useScreenVideoTrack,
  useVideoTrack,
} from '@daily-co/daily-react';
import { Box, Avatar, Stack, Text, Title, Space } from '@mantine/core';
import { useApp } from '../../../../context/AppContext';
import { useMemo } from 'react';

export const LocalParticipantVideoFeed = () => {
  const session = useLocalSessionId();
  const { isOff } = useVideoTrack(session);
  const { isOff: screenIsOff } = useScreenVideoTrack(session);
  const { profile } = useApp();

  const profileInitials = useMemo(() => {
    return profile?.fullName
      .split(' ')
      .map((n) => n[0])
      .join('');
  }, [profile?.fullName]);

  return (
    <div
      style={{
        position: 'absolute',
        top: '7px',
        left: '7px',
        zIndex: 10,
        maxWidth: '100%',
        maxHeight: '200px',
      }}
    >
      {isOff && screenIsOff && (
        <Box bg="#e3e3e3ff" p={0} m={0} h={200} w={125}>
          <Stack h={200} w={125} justify="center" align="center" gap={0}>
            <Avatar size={80} src={profile?.profilePicture}></Avatar>
            <Space h={10} />
            <Title order={3} c="dimmed">
              {profileInitials}
            </Title>
            <Text c="dimmed" fz="sm" ta="center">
              Video Disabled
            </Text>
          </Stack>
        </Box>
      )}
      <DailyVideo
        automirror={screenIsOff ? true : false}
        sessionId={session}
        type={screenIsOff ? 'video' : 'screenVideo'}
        style={{ maxWidth: '200px', maxHeight: '200px' }}
      />
    </div>
  );
};
